import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login'; // Make sure the path is correct
import AdminDashboard from './components/whoswho';
import CreateAdmin from './components/CreateAdmin';
import OdishaNavbar from './components/OdishaNavbar';
import Datasection from './components/Datasection';
import Navbar from './components/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import Carousel from './components/Carousel';
import Footer from './components/Footer';
import Marquee from './components/Marquee';
import AboutSections from './components/About';
import NoticeBoard from './components/NoticeBoard';
import Gallery from './components/Gallery';
import CategorySelector from './components/CategorySelector';
import PDFSelector from './components/PDFSelector';
import Header from './components/Header';
import UploadDocument from './components/Header';
import WhosWho from './components/whoswho';
import NotFound from './components/Error'; // import your 404 page
import WelcomePopup from './components/WelcomePopup';









const App = () => {
    return (
        <Router>

           
            <Routes>
                <Route path="/dashboard" element={<Login />} />
                <Route path="/*" element={
                    <>
                     <WelcomePopup />
                     <Header />
            <Navbar />
            <Routes>
                <Route path="/" element={
                    <>

                        <Carousel />
                        <Marquee />
                        <AboutSections />
                        <OdishaNavbar />
                        <NoticeBoard />
                        <Datasection />

                        
                        <Gallery />
                        
                    </>
                } />



           
                <Route path="/CategorySelector" element={<CategorySelector/>} />
                <Route path="/PDFSelector" element={< PDFSelector/>} />
                <Route path="/whoswho" element={< WhosWho />} />
                <Route path="/admin-dashboard" element={<AdminDashboard />} />
                <Route path="/create-admin" element={<CreateAdmin />} />
                <Route path="/upload-document" element={<UploadDocument />} />
                <Route path="*" element={< NotFound />} />


            </Routes>
            <Footer />
             </>
          }
        />
            </Routes>

        </Router>
    );
};

export default App;
